import { render, staticRenderFns } from "./change.vue?vue&type=template&id=af01235c&scoped=true&"
import script from "./change.vue?vue&type=script&lang=js&"
export * from "./change.vue?vue&type=script&lang=js&"
import style0 from "./change.vue?vue&type=style&index=0&id=af01235c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af01235c",
  null
  
)

export default component.exports